import React, { Component } from 'react';
import Container from '@mui/material/Container';
import Viewer from '../forge/Viewer';
import Projects from '../Data/sampleprojectdata.json';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';

import TempGauge from '../components/gauges/tempGauge';
import AlertsList from '../components/alerts/alertsList';
// import DemoData from '../components/DemoData';

const projectDetails = Projects.find(project => project.name === localStorage.getItem('projectName'))


class OperationsView extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  handleChange = name => event => {
    //if (name == "question1") 
    //event.target.value
  }

  render() {
    return (
      <>
        {(projectDetails) &&
          <>
            <Container sx={{ mt: 2, mb: 2, lg: 2 }} maxWidth="xl">
              <Grid container spacing={3}>                

                <Grid item xs={9} md={9} lg={9}>
                  <Paper
                    sx={{
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      height: 650,
                    }}
                  >
                    <Viewer
                        // key={Math.random()}
                        viewerDiv={'forgeViewer'}
                        urn={projectDetails.modelUrn}
                        showSensors={true}
                        extensions={['NestedViewerExtension', 'IssuesExtension', 'HeatmapExtension', 'Autodesk.Viewing.MarkupsGui']}
                        hasDwg={1}
                      />
                  </Paper>
                </Grid>

                <Grid item xs={3}>
                  <Paper
                    sx={{
                      p: 2, display: 'flex',
                      flexDirection: 'column',
                      height: 650,
                    }}>                                        
                    <AlertsList name="IOT Alarms"/>
                    
                  </Paper>
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                  <Paper
                    sx={{
                      p: 2, display: 'flex',
                      flexDirection: 'column',
                      height: 250,
                    }}>
                    <Stack
                      direction="row"
                      divider={<Divider orientation="vertical" flexItem />}
                      justifyContent="center"
                      alignItems="center"
                      spacing={2}                      
                    >
                       <TempGauge name="Oil Temp" min={0.15} max={0.20}/>
                       <TempGauge name="Winding Temp" min={0.22} max={0.28}/>
                       <TempGauge name="Air Temp" min={0.18} max={0.22}/>
                    </Stack>

                   
                  </Paper>
                </Grid>


              </Grid>
            </Container>

          </>
        }
        {
          !projectDetails &&
          <Container component="main" sx={{ mt: 12, mb: 12, lg: 12 }} maxWidth="lg">
            <Paper sx={{ p: 1, display: 'flex', flexDirection: 'column' }}>
              <h3>No Active Project Selected</h3>
            </Paper>
          </Container>
        }
      </>
    )
  }
}

export default OperationsView;